/*
 * Copyright (c) 2024-2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ValidationModel} from './validation.model';

export class WorkloadTimingSize extends ValidationModel {
    id: number;
    size: string;
    milestoneName: string;
    offsetFromSORP: number;
    workload: number;
    role: string

    setData(result) {
        this.id = result.id;
        this.size = result.size;
        this.milestoneName = result.milestoneName;
        this.offsetFromSORP = result.offsetFromSORP;
        this.workload = result.workload;
        this.role = result.role;
    }
}
